import { axiosInstance } from '../../../../Interceptors/axiosInterceptor';
import ApiUrlConstant from '../../../../Shared/Utils/UrlConstants';
import { store } from '../../../../Redux/Store';
import { setOrders } from '../../../../Shared/Slice/OrdersSlice';

const Service = {
  getOrderList: (id, options = {}) => {
    const { force = false } = options;
    const state = store.getState();
    const cached = state?.orders?.byId?.[id]?.data;
    if (cached && !force) {
      return Promise.resolve({ data: cached });
    }
    return axiosInstance.get(ApiUrlConstant.getOrderList(id), { loaderKey: 'get-orderList' }).then((res) => {
      try {
        const orders = res?.data || [];
        store.dispatch(setOrders({ id, orders }));
      } catch (e) {
        console.log(e);
      }
      return res;
    });
  },
};

export default Service;
